import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (otp: string) => void;
  handleResendEmail: () => void;
};

export const EmailRegistrationForm: React.FC<Props> = ({
  handleSubmit,
  handleResendEmail,
}) => {
  const schema = useMemo(() => {
    return z.object({
      otp: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ otp: "" }}
      onSubmit={({ otp }) => handleSubmit(otp)}
    >
      <StyledDescriptionContainer>
        <StyledTextContainer>
          メール認証を行います。メールで受信した6桁の認証番号を入力してください。
        </StyledTextContainer>

        <StyledInstructionContainer>
          <StyledInstructionTitle>
            メールが届いていない場合：
          </StyledInstructionTitle>

          <StyledInstructionList>
            <div>・</div>
            サーバーが混んでいる場合もございます。しばらく経ってから再度お試しください。
          </StyledInstructionList>

          <StyledInstructionList>
            <div>・</div>
            迷惑メールフォルダに振り分けられていないかご確認ください。
          </StyledInstructionList>
        </StyledInstructionContainer>
      </StyledDescriptionContainer>

      <Input label="認証番号" name="otp" autoFocus />

      <StyledFooter>
        <Button variant="filled" text="認証" type="submit" fullWidth />
        <Button
          variant="link"
          text="メールを再送信"
          type="button"
          onClick={handleResendEmail}
        />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-bottom: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledInstructionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledInstructionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
`;

const StyledInstructionList = styled.div`
  display: flex;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  gap: 20px;
`;

